import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

/**
 * This is a permissive type for abstract class constructors.
 * @docs-private
 */
// eslint-disable-next-line prettier/prettier
export type AbstractConstructor<T = object> = abstract new (...args: any[]) => T;

/** @docs-private */
export type Constructor<T> = new (...args: any[]) => T;

export interface AutoSubscription extends OnDestroy {
  readonly subscription: Subscription;
}

export function minxinSubscription<T extends AbstractConstructor<any>>(
  base: T
): AbstractConstructor<AutoSubscription> & T;
export function minxinSubscription<T extends Constructor<any>>(
  base: T
): Constructor<AutoSubscription> & T {
  return class extends base implements OnDestroy {
    protected readonly subscription = new Subscription();

    constructor(...args: any[]) {
      super(...args);
    }

    ngOnDestroy(): void {
      super.ngOnDestroy?.();
      this.subscription.unsubscribe();
    }
  };
}
